import { observable, action, runInAction } from 'mobx';
export class TickerStore {
    constructor(botStore) {
        this.botStore = botStore;
    }

    @observable tickers = null;

    @action async listen() {
        await this.botStore.proxy('ticker');

        this.botStore.socket.on('tickers', ({ data }) => {
            runInAction(() => {
                this.tickers = data;
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/stores/TickerStore.js